import { createContext, useContext } from 'react';
import type { RealtimeUpdate } from '@/services/realtime';

export interface RealtimeContextType {
  updates: RealtimeUpdate[];
  latestUpdate: RealtimeUpdate | null;
  isConnected: boolean;
  clearUpdates: () => void;
}

export const RealtimeContext = createContext<RealtimeContextType | undefined>(undefined);

export function useRealtimeContext(): RealtimeContextType {
  const context = useContext(RealtimeContext);
  if (!context) {
    throw new Error('useRealtimeContext must be used within a RealtimeProvider');
  }

  return context;
}
